var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppDialog',{attrs:{"closeRight":'-10',"closeTop":'-30',"disableMaxWidth":"","dialogName":'installationComplete',"width":"840px"}},[_c('div',{staticClass:"dialog-content rounded"},[_c('InstallationCompleteContent',{staticClass:"complete",attrs:{"wfId":_vm.wfId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }